import React, { useState } from "react";
import "./BubbleCard.css";

const BubbleCard = ({ image, name, title, description }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={`bubble-container ${isFocused ? "focused" : ""}`}
      tabIndex={0} // Enables keyboard focus
      onMouseOver={() => setIsFocused(true)}
      onMouseLeave={() => setIsFocused(false)}
    >
      <div className="bubble-card">
        {/* <img src={image} alt={name} className="bubble-photo" /> */}
        <h3 className="bubble-name">{name}</h3>
        <p className="bubble-title">{title}</p>
        <p className="bubble-description">{description}</p>
      </div>
    </div>
  );
};

export default BubbleCard;
